<template>
	<div>
		<!-- ================================= -->
		<h6 class="mb-2">Шрифт</h6>
		<div class="row">
			<div class="col-md-4">
				<b-form-select
					:disabled="!isText"
					v-model="currentFont"
					@change="changeFont"
					:style="{ fontFamily: currentFont }"
				>
					<b-form-select-option
						v-for="font in fonts"
						:key="font"
						:value="font"
						:style="{ fontFamily: font }"
						>{{ font }}</b-form-select-option
					>
				</b-form-select>
			</div>
		</div>
		<!-- ================================= -->
		<hr>

		<h6 class="mb-2 mt-4">Обводка текста</h6>
		
		<div class="row">
			<div class="col-md-4">
				<div class="mb-2">Толщина обводки</div>
				<b-form-input
					v-model="strokeWidth"
					type="range"
					min="0"
					max="10"
					:disabled="!isText"
					@input="updateOutline"
				></b-form-input>
			</div>
			<div class="col-md-3">
				<div class="mb-2">Цвет обводки</div>
				<b-form-input
					type="color"
					:disabled="!isText"
					v-model="strokeColor"
					@input="updateOutline"
				></b-form-input>
			</div>
		</div>
		<!-- ================================= -->
		<hr>
		<h6 class="mt-4">Анимация цвета</h6>
		<div class="mb-2">Скорость анимации {{ time / 1000 }}(сек)</div>
		<div class="row">
			<div class="col-md-4">
				<b-form-input
					v-model="time"
					type="range"
					min="500"
					max="5000"
					step="500"
					:disabled="!isText"
				></b-form-input>
			</div>
			<div class="col-md-4"></div>
			<div class="col-md-4"></div>
		</div>

		<p>Укажите от какого цвета к какому анимировать заливку</p>
		<div class="row">
			<div class="col-md-3">
				<div class="mb-2">Цвет 1</div>
				<b-form-input
					type="color"
					v-model="colors[0]"
				></b-form-input>
			</div>
			<div class="col-md-3">
				<div class="mb-2">Цвет 2</div>
				<b-form-input
					type="color"
					v-model="colors[1]"
				></b-form-input>
			</div>
			<div class="col-md-4 mt-auto">
				<b-button
					variant="outline-secondary"
					@click="rangeColorsAnimation"
				>
					Применить
				</b-button>
			</div>
		</div>

		<b-button
			class="mt-4"
			@click="randomColorsAnimation"
			variant="primary"
			size="sm"
			>Случайная цветовая анимация</b-button
		>
	</div>
</template>

<script>
import { fabric } from "fabric";

export default {
	props: [
		"canvas",
		"selectedType",
		"colorBrush",
		"valueShadowBlur",
		"colorShadow",
		"offsetShadow",
	],
	data() {
		return {
			strokeWidth: 0,
			strokeColor: "#000000",
			fonts: [
				"Roboto",
				"Lobster",
				"Pangolin",
				"Rubik",
				"Pacifico",
				"Cormorant Infant",
				"Hachi Maru Pop",
				"Kelly Slab",
				"Reggae One",
				"Stick",
			],
			currentFont: "Roboto",
			time: 500,
			colors: ["#00ff00", "#0000ff"],
		};
	},
	computed: {
		isText() {
			return this.selectedType === "text";
		},
	},
	methods: {
		randomColorsAnimation() {
			function getRandomColor() {
				var letters = "0123456789ABCDEF";
				var color = "#";
				for (var i = 0; i < 6; i++) {
					color += letters[Math.floor(Math.random() * 16)];
				}
				return color;
			}
			const target = this.canvas.getActiveObject();
			const canvas = this.canvas;
			let colors = ["#ffffff", getRandomColor()];
			let TIME = Number(this.time);
			// const swapColors = () => colors.push(colors.shift());
			const toRgba = (val) =>
				Array.isArray(val)
					? fabric.Color.fromSource(val).toRgba()
					: new fabric.Color(val).toRgba();

			target.set("animatedColor", true);

			const demoColorAnimation = () => {
				colors[1] = getRandomColor();
				fabric.util.animateColor(colors[0], colors[1], TIME, {
					onChange: (val) => {
						target.set("fill", toRgba(val));

						canvas.renderAll();
					},
					onComplete: () => {
						// swapColors();
						colors[0] = colors[1];
						demoColorAnimation();
					},
					abort: () => {
						return !target.animatedColor;
					},
				});
			};

			demoColorAnimation();
		},
		rangeColorsAnimation() {
			const target = this.canvas.getActiveObject();
			let colors = [...this.colors];
			const canvas = this.canvas;
			let TIME = Number(this.time);
			const swapColors = () => colors.push(colors.shift());
			const toRgba = (val) =>
				Array.isArray(val)
					? fabric.Color.fromSource(val).toRgba()
					: new fabric.Color(val).toRgba();

			target.set("animatedColor", true);

			const demoColorAnimation = () => {
				fabric.util.animateColor(colors[0], colors[1], TIME, {
					onChange: (val) => {
						target.set("fill", toRgba(val));

						canvas.renderAll();
					},
					onComplete: () => {
						swapColors();
						demoColorAnimation();
					},
					abort: () => {
						return !target.animatedColor;
					},
				});
			};

			demoColorAnimation();
		},
		changeFont() {
			this.canvas.getActiveObject().set("fontFamily", this.currentFont);
			// this.canvas.getActiveObject().width += 1;
			// this.canvas.requestRenderAll();
			setTimeout(() => {
				this.canvas.requestRenderAll();
				this.canvas.renderAll();
			}, 100);
		},
		addText() {
			var textbox = new fabric.Textbox("введите текст...", {
				left: 100,
				top: 100,
				fill: this.colorBrush,
				fontFamily: this.currentFont,
				shadow: `${this.colorShadow} ${this.offsetShadow.x} ${this.offsetShadow.y} ${this.valueShadowBlur}`,
				paintFirst: "stroke",
			});
			this.canvas.add(textbox).setActiveObject(textbox);
			this.$emit("enableEditingMode");
		},
		updateOutline() {
			const target = this.canvas.getActiveObject();

			target.set("stroke", this.strokeColor);
			target.set("strokeWidth", Number(this.strokeWidth));
			console.log("strokeWidth = ", this.strokeWidth);
			this.canvas.renderAll();
		},
	},
};
</script>

<style></style>
